import { companyUserEndpoints, companyEndpoints } from '@/api/apiEndpoint'
import { apiService } from './apiService'
import { DefaultResponse } from '@/common/types/common'

/**
 * 회사 사용자 정보 DTO
 */
export interface CompanyUserDto {
  id: number;
  name?: string;
  isMaster: boolean;
  nickname?: string;
  email?: string;
  position?: string;
}

/**
 * 가입 신청 사용자 DTO
 */
export interface ApplyCompanyUserDto {
  notificationId: string;
  name?: string;
  email?: string;
  isAccepted?: boolean;
  rejectReason?: string;
  expiresAt: string;
}

/**
 * 회사 사용자 관련 서비스
 */
export const companyUserService = {

  /**
   * 이메일 중복 검사
   * @param email 이메일
   * @returns 중복 여부
   */
  checkDuplicateEmail: async (email: string): Promise<{exists: boolean}> => {
    const response = await apiService.get<{exists: boolean}>(
      companyUserEndpoints.checkDuplicateEmail(),
      {email}
    )
    return response
  },

  /**
   * 회사 사용자 목록 조회
   * @param companyId 회사 ID
   * @returns 회사 사용자 목록
   */
  getCompanyUserList: async (companyId: number): Promise<CompanyUserDto[]> => {
    const response = await apiService.get<CompanyUserDto[]>(
      companyUserEndpoints.getCompanyUserList(companyId)
    )
    return response
  },

  /**
   * 마스터 사용자 설정
   * @param companyUserId 회사 사용자 ID
   * @returns 성공 응답
   */
  setMaster: async (companyUserId: number): Promise<DefaultResponse> => {
    const response = await apiService.post<DefaultResponse>(
      companyUserEndpoints.setMaster(companyUserId),
      {}
    )
    return response
  },

  /**
   * 마스터 사용자 제거
   * @param companyUserId 회사 사용자 ID
   * @returns 성공 응답
   */
  removeMaster: async (companyUserId: number): Promise<DefaultResponse> => {
    const response = await apiService.post<DefaultResponse>(
      companyUserEndpoints.removeMaster(companyUserId),
      {}
    )
    return response
  },

  /**
   * 가입 신청 목록 조회
   * @param companyId 회사 ID
   * @returns 가입 신청 목록
   */
  getApplyCompanyUsers: async (companyId: number): Promise<ApplyCompanyUserDto[]> => {
    const response = await apiService.get<ApplyCompanyUserDto[]>(
      companyEndpoints.getApplyCompanyUsers(companyId)
    )
    return response
  },
}

